import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TeamMembersContainer = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isActive";
  },
})<{ isActive?: boolean }>(({ isActive }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "6px",
  width: "100%",
  color: isActive ? colors.gray600 : colors.gray400,
}));

export const TeamMembersIcon = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px",
}));

export const TeamMembers = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isCentered";
  },
})<{ isCentered?: boolean }>(({ isCentered }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  justifyContent: isCentered ? "center" : undefined,
  alignSelf: "stretch",
  padding: "0 4px",

  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));
